module.exports = __webpack_public_path__ + "img/Scotland.7fd3f08b.png";